import { AsyncPipe, NgIf } from '@angular/common';
import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { AuthorizationService } from '@myapp/modules/fwcore/services';
import { GridModule, AddEvent } from '@progress/kendo-angular-grid';
import { State } from '@progress/kendo-data-query';
import { Subject, forkJoin } from 'rxjs';
import { ControlResizerOptions, ControlResizerService } from '../../../../../../services/framework';
import { NullableBooleanClassDirective } from '../../../../../modules/fwcore/directives/nullable-boolean-class.directive';
import { DatePreferencePipe } from '../../../../../modules/fwcore/pipes/date-preference.pipe';
import { UserState, UserStateChecked, Module, IUser, RequestModuleUserSet, ModuleChecked, IUserLicenseEditor, UserImport } from '../../../models';
import { RequestUserImportSet, RequestUserState } from '../../../models/messages';
import { AdminService } from '../../../services';
import { UserStateGridService } from '../../../services/grids';
import { UserGridEditorComponent } from "../user-grid-editor/user-grid-editor.component";
import { BaseGridComponent } from '../../base-grid/base-grid.component';
import { LicenseUserEditForm } from '../user-grid-editor/LicenseUserEditForm';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { takeUntil, finalize, map } from "rxjs/operators";

@Component({
  selector: 'app-user-state',
  templateUrl: './user-state.component.html',
  styleUrls: ['./user-state.component.scss'],
  standalone: true,
  imports: [GridModule, NullableBooleanClassDirective, NgIf, AsyncPipe, DatePreferencePipe, UserGridEditorComponent]
})

export class UserStateComponent extends BaseGridComponent<UserState> implements OnInit, OnDestroy {

  /*-------------------------- Input / Outputs ------------------------*/

  @Input() public companyId: string | null = null;
  @Input() public licenseId: string | null = null;


  @Input()
  set assigned(value: boolean | null) {
    this.req.assigned = value;

    if (this.viewInit) {
      this.getData();
    }
  }
  get assigned(): boolean | null {
    return this.req.assigned ?? null;
  }

  @Input()
  set active(value: boolean | null) {
    this.req.active = value;

    if (this.viewInit) {
      this.getData();
    }
  }
  get active(): boolean | null {
    return this.req.active ?? null;
  }

  @Input()
  set startsWith(value: string) {

    this.startsWithSearch = value;

    if (this.viewInit) {

      if (value && value.length > 2) {
        // Only update 
        this.req.startsWith = value;
        this.getData();
      }
      else if (value && value.length > 0) {
        this.req.startsWith = null;
      }
      else {
        this.req.startsWith = null;
        this.getData();
      }
    }

  }

  get startsWith(): string {
    return this.startsWithSearch;
  }

  @Input()
  set checkedIds(ids: string[]) {
    this.dataItems.forEach((item) => {
      item.checked = ids.includes(item.id!);
    });
  }

  get checkedIds(): string[] {

    const checkedItemIds: string[] = this.gridService.value.data
      .filter((item) => item.checked)
      .map((item) => item.id!)

    return checkedItemIds ?? [];
  }

  /*-------------------------- public properties / methods ------------*/

  public heightChange(options?: ControlResizerOptions): void {

    let ctrlOptions: ControlResizerOptions = new ControlResizerOptions();
    ctrlOptions.elemTop = this.elem.nativeElement.getBoundingClientRect().top;

    if (options) {
      ctrlOptions = { ...options, elemTop: ctrlOptions.elemTop };
    }

    const h = this.controlResizer.calculateHeight(ctrlOptions);
    this.heightGrid = h;

  }

  /*-------------------------- Internal properties  -------------------*/

  protected dataItems: UserStateChecked[] = [];

  protected editDataItem?: UserState;

  protected isNew?: boolean;

  protected modules: ModuleChecked[] = [];

  protected userModules: RequestModuleUserSet = {

  }

  result: any = [];

  protected heightGrid!: number;

  protected destroy$ = new Subject();

  /*-- State --*/

  public viewInit: boolean = false;

  protected loading: boolean = true;

  protected state: State = {
    skip: 0
    , take: 15
    , sort: []
  }

  protected req: RequestUserState = {
    skip: 0
    , take: 15
    , assigned: null
    , active: null
    , startsWith: null
  };

  protected startsWithSearch: string = "";

  /*--------------------------- Constructor  --------------------------*/

  constructor(protected gridService: UserStateGridService
    , adminService: AdminService
    , protected serviceAuth: AuthorizationService
    , protected controlResizer: ControlResizerService
    , protected router: Router
    , protected elem: ElementRef
    , modalService: NgbModal) {
    super(adminService, modalService);

  }

  /*--------------------------- ng  -----------------------------------*/


  ngOnInit(): void {

    this.req.companyId = this.companyId;
    this.req.licenseId = this.licenseId;
    this.req.assigned = this.assigned;
    this.req.active = this.active;

    this.getData();

    this.viewInit = true;
    this.sizeChange();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /*--------------------------- event handlers  -----------------------*/

  @HostListener('window:resize', ['$event'])
  protected onResize(event: Event) {
    this.sizeChange();
  }

  // -------------- Grid processing ------------------------------------------------

  protected onStateChange(state: State): void {

    this.state = state;

    this.req.skip = this.state.skip;
    this.req.take = this.state.take;

    this.getData();
  }

  /*--------------------------- internal functions  -------------------*/

  protected sizeChange() {

    if (this.viewInit) {
      var options: ControlResizerOptions = new ControlResizerOptions();

      this.heightGrid = this.controlResizer.calculateHeight(options);
    }
  }

  protected getData() {

    this.gridService.query(this.req);
  }

  retrieveItems(): void {
  }


  refreshItems(): void {
    this.getData();
  }

  saveItem(item: IUserLicenseEditor, isNew: boolean): void {

    var test = item;

    this.userModules.firstName = item.firstName;
    this.userModules.lastName = item.lastName;
    this.userModules.userProfileEmail = item.email;
    this.userModules.data = item.checkedIds;

    this.isNew = true;//post method

    //------------------------------------------
    let data: UserImport = {
      modules: item.checkedIds,
      firstName: item.firstName,
      lastName: item.lastName,
      email: item.email
    }

    let dataItems1: UserImport[] = [];
    dataItems1.push(data);

    const req: RequestUserImportSet = {
        licenseId: this.licenseId
      , companyId: this.companyId
      , data: dataItems1
    };

    this.adminService.setUserImport$(req)
      .subscribe(
        _response => {
          this.refreshItems();
        },
        error => {
          // Raise Error
          console.error(error);
        });
    //------------------------------------------

    //this.adminService.saveLicenseUserModules(this.userModules, this.isNew)
    //  .subscribe(
    //    _response => {
    //      this.refreshItems();
    //    },
    //    error => {
    //      // Raise Error
    //      console.error(error);
    //    });
  }



  public addHandler({ sender }: any) {

  }

  public editHandler({ sender, rowIndex, dataItem }: any) {
    const size = 'lg';
    const options = {
      title: "Edit User", windowClass: "modal-preferences",
      showSave: true, showCancel: true, showCross: true, scrollable: false
    };

    forkJoin([
      this.adminService.getAllUserModules(dataItem.email)
    ]).pipe(takeUntil(this.destroy$))
      .subscribe(
        data => {
          this.modules = data[0].data;
          dataItem.modules = this.modules;
          dataItem.userModules = this.modules.filter(x => x.licenseUserID != null).map(x => x.name);
          this.showEditorModal(size, options, UserGridEditorComponent, new LicenseUserEditForm(dataItem), false);
        }
      );
  }

  public removeHandler({ dataItem }: any): void {

  }

}
